export default function isBetween(date, start, end) {
	const d = new Date(date);

	return d >= new Date(start) && d <= new Date(end);
}
